import React from "react";
import { Star, FileCheck, Users, Wrench } from "lucide-react";

const testimonials = [
  {
    quote:
      "It does what we've been doing the long way for 20 years — in a fraction of the time. Every commercial sparks I know will want one.",
    name: "Daniel R.",
    role: "Commercial Electrician · Manchester",
  },
  {
    quote:
      "The repeatability alone makes this a no-brainer for our panel shop. Every enclosure looks the same — professional, every time.",
    name: "Sophie K.",
    role: "Panel Builder · Birmingham",
  },
  {
    quote:
      "Finally, a tool designed by someone who's actually been on site. You can tell from the moment you pick it up.",
    name: "Marcus T.",
    role: "Industrial Contractor · Leeds",
  },
];

const milestones = [
  { icon: Wrench, label: "Prototype v3 Complete", date: "Q3 · 2025" },
  { icon: FileCheck, label: "Patent Application Filed", date: "Q3 · 2025" },
  { icon: Users, label: "Trade Validation Trials", date: "Q4 · 2025" },
  { icon: Star, label: "Wholesaler Engagement", date: "Q1 · 2026" },
];

export const MarketValidation = () => {
  return (
    <section
      data-testid="market-validation"
      className="relative py-24 md:py-36 border-t border-[#27272A] bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="label-eyebrow">07 / Market Validation</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4">
            Trusted by the trade.{" "}
            <span className="text-[#FF6B00]">Backed by progress.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#27272A] border border-[#27272A] mb-14">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i + 1}`}
              className="bg-[#0A0A0A] p-7 md:p-9 hover:bg-[#141414] transition-colors flex flex-col"
            >
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, idx) => (
                  <Star
                    key={idx}
                    className="w-4 h-4 fill-[#FF6B00] text-[#FF6B00]"
                  />
                ))}
              </div>
              <p className="text-white/90 text-[15px] md:text-base leading-relaxed flex-1">
                &quot;{t.quote}&quot;
              </p>
              <div className="mt-6 pt-5 border-t border-[#27272A]">
                <div className="font-display text-base">{t.name}</div>
                <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA] mt-1">
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Milestones */}
        <div className="border border-[#27272A] bg-[#141414]/60 rounded-sm">
          <div className="px-6 md:px-8 py-5 border-b border-[#27272A] flex items-center justify-between">
            <span className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA]">
              Development Milestones
            </span>
            <span className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#FF6B00]">
              ● Patent Pending
            </span>
          </div>
          <div
            data-testid="milestones-grid"
            className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#27272A]"
          >
            {milestones.map((m, i) => (
              <div
                key={m.label}
                className="bg-[#0A0A0A] p-6 md:p-7 flex flex-col gap-3"
              >
                <div className="flex items-center justify-between">
                  <div className="w-10 h-10 grid place-items-center bg-[#1F1F1F] border border-[#27272A] rounded-sm">
                    <m.icon className="w-4 h-4 text-[#FF6B00]" strokeWidth={2} />
                  </div>
                  <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="font-display text-lg md:text-xl tracking-tight">
                  {m.label}
                </div>
                <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#D4D4D8]">
                  {m.date}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
